export const spanishLocaleText = {
  filterOoo: "Filtrar...",
  equals: "Igual",
  notEqual: "No igual",
  lessThan: "Menor que",
  greaterThan: "Mayor que",
  inRange: "En rango",
  contains: "Contiene",
  notContains: "No contiene",
  startsWith: "Comienza con",
  endsWith: "Termina con",
  andCondition: "Y",
  orCondition: "O",
  applyFilter: "Aplicar",
  resetFilter: "Reiniciar",
  clearFilter: "Limpiar",
  page: "Página",
  to: "a",
  of: "de",
  nextPage: "Siguiente página",
  lastPage: "Última página",
  firstPage: "Primera página",
  previousPage: "Página anterior",
  loadingOoo: "Cargando...",
  noRowsToShow: "Sin datos para mostrar",
};

export const ITEMS_PER_PAGE = 50;

export const requiredFields = [
  { field: "name", message: "Nombre es obligatorio" },
  { field: "documentType", message: "Tipo de documento es obligatorio" },
  {
    field: "expirationNoticeDays",
    message: "Anticipación de vencimiento es obligatoria",
  },
  { field: "expirationGraceDays", message: "Tolerancia es obligatoria" },
  {
    field: "expirationReminderRepeatDays",
    message: "Repetición de alarma es obligatoria",
  },
];
